import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import useUserServiceGetHook from "../../customHooks/useUserServiceGetHook";
import usePDFPrintHook from "../../customHooks/usePDFPrintHook";
import print from "print-js";
import { useState } from "react";

const EditOrderComponent = loadable(
  () => import("../../components/Order/EditOrder")
);
const EditOrder = () => {
  const { id } = useParams()
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)
  const [openPrintPopup, setOpenPrintPopup] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const { data: order, isLoading } = useGetHook({
    queryKey: [`order-${id}`],
    url: `${APIS.ORDER}${id}/`,
    params: {},
  });

  const { mutateAsync: calculateDeliveryCharge, isPostLoading: isDeliveryChargeCalculating } = usePostHook({
    queryKey: [],
    navigateURL: "",
  });

  const { data: clientType, isLoading: clientTypeLoading } = useGetHook({
    queryKey: [`client-type`],
    url: `${APIS.CLIENT_TYPE}`,
    params: {},
  });


  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { mutateAsync: downloadPrint, isPostLoading: isPrintLoading } = usePDFPrintHook({
    queryKey: [],
  });

  const handleLabelPrintDownload = async () => {

    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedOrder]
    };
    try {
      const res = await downloadPrint({ url, formData });
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL)
    } catch (err) {
      console.log(err);
    }
  }

  const handleOrderReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedOrder]
    };
    try {
      const res = await downloadPrint({ url, formData });
      const fileURL = URL.createObjectURL(res?.data);
      print(fileURL)
    } catch (err) {
      console.log(err);
    }
  }

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}${id}/`;
    console.log(values)
    let formData = {
      ...values
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 200) {
        setOpenPrintPopup(true)
        setSelectedOrder(id)
      }
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: createCustomerMutateAsync, isPostLoading: createCustomerLoading } = usePostHook({
    queryKey: ["customers"],
    navigateURL: "/customer",
  });

  const handleCreateCustomer = async (values: any, setError: any) => {
    const url = `${APIS.CUSTOMER}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.mobile_number}`,
      "secondary_contact": values?.secondary_contact ? `+977${values?.secondary_contact}` : `+977${values?.mobile_number}`
    };
    try {
      await createCustomerMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Consignment</span>
      </div>
      {isLoading || clientTypeLoading ? <Spinner /> :
        <EditOrderComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          order={order}
          handleCreateCustomer={handleCreateCustomer}
          createCustomerLoading={createCustomerLoading}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          profile={profile}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleOrderReceiptDownload={handleOrderReceiptDownload}
          isPrintLoading={isPrintLoading}
          clientType={clientType}
          calculateDeliveryCharge={calculateDeliveryCharge}
          isDeliveryChargeCalculating={isDeliveryChargeCalculating}
        />
      }

    </>
  );
};
export default EditOrder;
